<div class="col-6 content-card px-0" id="print-section-essay"
     *ngIf="convertedText && convertedText != '' && previousFeedBack?.length != 0">

    <div class="mt-3 col-12">
        <div class="card">
            <div class="card-body custom_feedback_card_body">
                <div class="row px-2">
                    <div class="col-1 text-center align-self-center pr-0">
                        <h5 class="font-weight-bold d-flex flex-column mb-0" *ngIf="selectedPreviousStudentAnswer?.created_date">
                            <span>{{selectedPreviousStudentAnswer?.created_date | date: 'MMM' | uppercase }} </span>
                            <span class="my-2">{{selectedPreviousStudentAnswer?.created_date | date: 'd'}} </span>
                            <span>{{selectedPreviousStudentAnswer?.created_date | date: 'y'}} </span>
                        </h5>
                    </div>
                    <div class="col-11">
                        <h3 style="font-size: 30px !important;" class="content-heading-name mb-1 text-capitalize">
                            {{contentName}}<span class="f-18 font-weight-bold" style="color: #212529"> - Version {{selectedFeedBackIndex}}</span>
                        </h3>
                        <h5><span style="color: #666666" class="mr-2 f-18">by</span>
                            <span class="f-18 font-weight-bold text-capitalize">{{studentAnswer.student_name}}</span></h5>
                        <h5><span style="color: #666666" class="mr-2 f-18">for</span>
                            <span class="f-18 font-weight-bold text-capitalize">{{studentAnswer.class_name}}</span></h5>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="mt-3 editor_bullet col-md-12">
        <div class="card">
            <div class="card-header p-3 background_gradient">
                <h5 style="color: white" class="font-weight-bold">Essay Prompt</h5>
            </div>
            <div class="card-body p-3 custom_feedback_card_body">
                <span [innerHTML]="convertMarkdownToHtml(totalAns[0]?.question, 'single')" class="innerhtml-margin-clear f-18"></span>
            </div>
        </div>
    </div>

    <div *ngIf="totalAns[0]?.student_answer[0]?.isSelected != ''" class="mt-3 editor_bullet col-md-12">
        <div class="card">
            <div class="card-header p-3 background_gradient">
                <h5 style="color: white" class="font-weight-bold">{{studentLogin ? 'Your' : 'Student'}} Answer</h5>
            </div>
            <div class="card-body p-3 custom_feedback_card_body">
                <span [innerHTML]="convertedText && convertedText != '' ? convertMarkdownToHtml(selectedPreviousStudentAnswer?.student_answer) : convertMarkdownToHtml(totalAns[0]?.student_answer[0]?.isSelected, 'single')" class="innerhtml-margin-clear f-18"></span>
            </div>
        </div>
    </div>

    <div class="col-md-12 mt-3 mb-0" *ngIf="totalAns[0]?.student_roughdata != '' && totalAns[0]?.student_roughdata">
        <div class="card mb-0">
            <div class="card-header p-3 background_gradient">
                <h5 style="color: white" class="font-weight-bold">Cited Source</h5>
            </div>
            <div class="card-body editor_bullet custom_feedback_card_body p-3">
                <span [innerHTML]="totalAns[0]?.student_roughdata | sanitizeHtml" class="innerhtml-margin-clear f-18"></span>
            </div>
        </div>
    </div>

    <div id="feedback_got_essay" class="col-12 row pr-0 content-card"
         *ngIf="previousFeedBack.length != 0 && convertedText != ''">

        <div class="feedback-card p-0" style="height: 74vh; border: 0 !important;" *ngIf="selectedPreviousStudentAnswer?.version == 'V1'"
             [innerHTML]="convertedText"></div>

        <div class="col-12 pr-0" *ngIf="selectedPreviousStudentAnswer?.version != 'V1'">
            <h5 *ngIf="selectedFeedBackIndex == previousFeedBack.length"
                class="font-weight-bold">Final Feedback<span *ngIf="selectedPreviousStudentAnswer?.created_date"> ({{selectedPreviousStudentAnswer?.created_date | customDateFormat}} | {{selectedPreviousStudentAnswer?.created_date | date:'h:mm a'}}) </span>: </h5>
            <h5 *ngIf="selectedFeedBackIndex != previousFeedBack.length"
                class="font-weight-bold">Feedback For Version {{selectedFeedBackIndex}}<span *ngIf="selectedPreviousStudentAnswer?.created_date"> ({{selectedPreviousStudentAnswer?.created_date | customDateFormat}} | {{selectedPreviousStudentAnswer?.created_date | date:'h:mm a'}}) </span>: </h5>
            <div class="col-12 px-0" *ngIf="selectedPreviousStudentAnswer?.version != 'V1'">
                <div class="card">
                    <div class="card-header p-3 background_gradient">
                        <h5 style="color: white;font-size: 16px" class="font-weight-bold">Score Chart</h5>
                    </div>
                    <div class="card-body custom_feedback_card_body p-3">
                        <div class="row justify-content-center flex-column">
                            <div class="col-12 d-flex justify-content-center">
                                <div class="text-center">
                                    <h5 class="font-weight-bold">Feedback Score</h5>
                                    <p style="font-size: 14px" class="mb-0">
                                        <span>Current Version : <span style="color: #008ffb" class="font-weight-bold">
                                            {{selectedPreviousStudentAnswer?.student_score}} / {{selectedPreviousStudentAnswer?.total_score}}</span></span>
                                        <span class="ml-2">Previous Version :<span style="color: #2daf83" *ngIf="selectedFeedBackIndex != 1 && selectedFeedBackIndex != ''" class="font-weight-bold">
                                            {{previousFeedBack[selectedPreviousStudentAnswer?.index + 1].student_score}} / {{previousFeedBack[selectedPreviousStudentAnswer?.index + 1].total_score}}
                                        </span>
                                        <span *ngIf="selectedFeedBackIndex == 1"> - </span></span>
                                    </p>
                                </div>
                            </div>

                            <div class="col-12">
                                <div id="chart2">
                                    <apx-chart
                                            [series]="chartOptions?.series"
                                            [chart]="chartOptions?.chart"
                                            [xaxis]="chartOptions?.xaxis"
                                            [yaxis]="chartOptions?.yaxis"
                                            [plotOptions]="chartOptions?.plotOptions"
                                            [dataLabels]="chartOptions?.dataLabels"
                                            [legend]="chartOptions?.legend">
                                    </apx-chart>
                                </div>
                            </div>

                            <div class="col-12 mt-2" *ngIf="selectedPreviousStudentAnswer?.strengths">
                                <div *ngIf="selectedPreviousStudentAnswer?.strengths?.length != 0">
                                    <label class="font-weight-bold">Strengths: </label>
                                    <h5 class="strength_text" *ngFor="let value of selectedPreviousStudentAnswer?.strengths">{{value}}</h5>
                                </div>
                            </div>

                            <div class="col-12 mt-3" *ngIf="selectedPreviousStudentAnswer?.top_opportunities">
                                <div *ngIf="selectedPreviousStudentAnswer?.top_opportunities?.length != 0">
                                    <label class="font-weight-bold">Top Opportunities: </label>
                                    <h5 class="top_opportunity_text" *ngFor="let value of selectedPreviousStudentAnswer?.top_opportunities">{{value}}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 mt-3 px-0">
                <div class="card">
                    <div class="card-header p-3 background_gradient">
                        <h5 style="color: white;font-size: 16px" class="font-weight-bold">Trait Analysis</h5>
                    </div>
                    <div class="card-body custom_feedback_card_body p-3">
                        <div style="border: 0 !important;" class="feedback-card" *ngIf="selectedPreviousStudentAnswer?.version == 'V1'" [innerHTML]="convertedText"></div>
                        <div class="feedback-card p-0" *ngIf="selectedPreviousStudentAnswer?.version != 'V1'" style="overflow-x: hidden;border: 0 !important">
                            <div class="row mb-2">
                                <div class="col-12">
                                    <h5 style="font-size: 18px" class="mb-0 font-weight-bold">Total Score</h5>
                                    <div class="row">
                                        <div class="col-10">
                                            <div class="progress my-2">
                                                <div class="progress-bar"
                                                     role="progressbar"
                                                     [style.width.%]="scorePercentage"
                                                     [attr.aria-valuenow]="score"
                                                     [attr.aria-valuemin]="0"
                                                     [attr.aria-valuemax]="totalScore">
                                                </div>
                                            </div>
                                        </div>
                                        <span class="align-self-center col-2 font-weight-bold color-primary">{{selectedPreviousStudentAnswer?.student_score}} / {{selectedPreviousStudentAnswer?.total_score}}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="my-1" *ngFor="let feedback of feedbackList; let last = last; let first = first" (click)="feedback.collaspsed = !feedback.collaspsed">
                                <div class="row">
                                    <div class="col-4">
                                        <span class="title-text col-12">{{ getValue(feedback[0]) ?? '-' }}</span>
                                        <div style="padding: 0 12px" class="stars col-12 my-1">
                                            <ng-container *ngFor="let s of stars; let i = index">
                                                <i class="fa" [ngClass]="{'fa-star': feedback[1]?.score >= i + 1,'fa-star-half-o': feedback[1]?.score >= i + 0.5 && feedback[1]?.score < i + 1,
                                                'fa-star-o': feedback[1]?.score < i + 0.5}"></i>
                                            </ng-container>
                                        </div>
                                        <span style="padding: 0 12px" class="col-12 score-text ml-0"><span class="text-capitalize">{{studentLogin ? 'You' : studentAnswer.student_name}}</span> scored <b>{{feedback[1]?.score}}</b> out of <b>{{totalIndivialScore}}</b></span>
                                    </div>

                                    <div class="col-8">
                                        <div *ngIf="feedback[1]?.rationale" class="rationale_design col-12 px-0 {{feedback[1]?.feedback?.length == 0 || !feedback[1]?.feedback ? 'mb-0' : ''}}">
                                            <span><strong style="color: black">Rationale:</strong> {{ feedback[1]?.rationale }}</span>
                                        </div>

                                        <div class="row" *ngIf="feedback[1]?.feedback?.length != 0  && feedback[1]?.feedback">
                                            <div class="col-md-12 my-2" *ngFor="let value of feedback[1]?.feedback; let lastValue = last">
                                                <div class="collapse-card">
                                                    <h5 style="color: #212529" *ngIf="value?.snippet" class="snippet-text mb-3">{{ value?.snippet }}</h5>

                                                    <div class="inner-collapse mt-2">
                                                        <label *ngIf="value?.suggestion" class="font-weight-bold col-12 px-0">Suggestion: <span class="font-weight-normal italic">{{ value?.suggestion ?? '-'}}</span></label>

                                                        <label *ngIf="value?.why" class="font-weight-bold mt-2 col-12 px-0">Why: <span class="font-weight-normal italic">{{ value?.why ?? '-'}}</span></label>

                                                        <label *ngIf="value?.example_rewrite" class="font-weight-bold mt-2 col-12 px-0 mb-0">Example: <span class="font-weight-normal color-primary italic">{{ value?.example_rewrite ?? '-'}}</span></label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 mt-3 px-0" *ngIf="selectedPreviousStudentAnswer?.next_edit_plan && selectedPreviousStudentAnswer?.next_edit_plan?.length != 0">
                <div class="card">
                    <div class="card-header p-3 background_gradient">
                        <h5 style="color: white;font-size: 16px" class="font-weight-bold">Next Edit Plan</h5>
                    </div>
                    <div class="card-body custom_feedback_card_body py-3 px-0">
                        <div class="col-12 row {{!last ? 'mb-2' : ''}}" *ngFor="let data of selectedPreviousStudentAnswer?.next_edit_plan; let i = index; let last = last">
                            <div style="width: 6%;padding-left: 16px" class="text-center font-weight-bold">{{data?.priority ?? i}}.</div>
                            <div style="width: 94%;">
                                <label class="font-weight-bold mb-1 col-12 px-0">{{data?.action ?? ''}}</label>
                                <label *ngIf="data?.example_rewrite" style="color: #007BFF">Example: <span class="color-primary col-12 px-0">{{data?.example_rewrite ?? '-'}}</span></label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="totalFeedBack != ''" class="mt-3 editor_bullet col-md-12">
        <div class="card">
            <div class="card-header p-3 background_gradient">
                <h5 style="color: white" class="font-weight-bold">Teacher FeedBack</h5>
            </div>
            <div class="card-body p-3 custom_feedback_card_body">
                <span class="innerhtml-margin-clear f-18">{{totalFeedBack}}</span>
            </div>
        </div>
    </div>

</div>
